<template>
  <div>
    <!-- Bottone Richiesta Assistenza -->
    <button @click="showConfirmModal = true" class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-4 h-36 flex flex-col items-center justify-start text-center cursor-pointer hover:shadow-lg transition w-full sm:w-48">
      <img :src="`/images/icons/reception-digitale/richiesta-assistenza.png`" class="h-14 mb-2">
      <p class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-1">
        {{ $t('ui.richiesta_assistenza.title_it') }}
        <br>
        <span class="text-xs text-gray-600 dark:text-gray-400">{{ $t('ui.richiesta_assistenza.title_en') }}</span>
      </p>
    </button>

    <!-- Modale di Conferma -->
    <ConfirmationModal :show="showConfirmModal" @close="showConfirmModal = false">
      <template #title>
        {{ $t('ui.richiesta_assistenza.title_it') }}
        <br>
        <span class="text-xs text-gray-600 dark:text-gray-400">{{ $t('ui.richiesta_assistenza.title_en') }}</span>
      </template>
      <template #content>
        {{ $t('ui.richiesta_assistenza.sure_it') }}
        <br>
        <span class="text-xs text-gray-600 dark:text-gray-400">{{ $t('ui.richiesta_assistenza.sure_en') }}</span>
      </template>
      <template #footer>
        <SecondaryButton @click="showConfirmModal = false" :disabled="isLoading">
          <span>{{ $t('ui.richiesta_assistenza.cancel_it') }} <span class="text-xs">({{ $t('ui.richiesta_assistenza.cancel_en') }})</span></span>
        </SecondaryButton>
        <DangerButton class="ms-3" @click="confermaRichiestaAssistenza" :disabled="isLoading">
          <span v-if="isLoading">
            {{ $t('ui.richiesta_assistenza.sending_it') }}
            <br>
            <span class="text-xs text-gray-600 dark:text-gray-400">{{ $t('ui.richiesta_assistenza.sending_en') }}</span>
          </span>
          <span v-else>
            {{ $t('ui.richiesta_assistenza.confirm_it') }} <span class="text-xs">({{ $t('ui.richiesta_assistenza.confirm_en') }})</span>
          </span>
        </DangerButton>
      </template>
    </ConfirmationModal>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import DangerButton from '@/Components/DangerButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';

export default {
  name: 'RichiestaAssistenza',
  components: {
    ConfirmationModal,
    DangerButton,
    SecondaryButton
  },
  data() {
    return {
      showConfirmModal: false,
      isLoading: false
    };
  },
  methods: {
    async confermaRichiestaAssistenza() {
      this.isLoading = true;
      
      try {
        // Effettua la chiamata axios alla rotta modules.rd-richiesta-assistenza
        const response = await axios.get(route('modules.rd-richiesta-assistenza'));

        // La risposta contiene {requestForAssistance: <id>}
        const { requestForAssistance } = response.data;

        // Chiudi la modale
        this.showConfirmModal = false;
        
        // Reindirizza alla rotta rd-assistenza-confermata passando il parametro requestForAssistance
        router.visit(route('modules.rd-assistenza-confermata', { requestForAssistance }));
        
      } catch (error) {
        console.error('Errore nella richiesta assistenza:', error);
        alert(this.$t('ui.richiesta_assistenza.error_alert'));
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
